import script from "./SQLSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./SQLSelector.vue?vue&type=script&setup=true&lang=js"

import "./SQLSelector.vue?vue&type=style&index=0&id=4826cc56&lang=scss"

const __exports__ = script;

export default __exports__